module.exports = __webpack_public_path__ + "img/voideBg2.9041c493.jpg";